<script setup lang="ts">
import { AppDrawer } from '@libs/ui';

import { useActivityDetailsStore } from '../../stores';
import TicketsSelectorMobileLoader from '../loaders/TicketsSelectorMobileLoader.vue';

import TicketsSelectorMobile from './TicketsSelectorMobile.vue';

const activityDetailsStore = useActivityDetailsStore();

interface TicketsSelectorPanelEmits {
  (event: 'close'): void;
  (event: 'select-tickets'): void;
}
const emit = defineEmits<TicketsSelectorPanelEmits>();
</script>

<template>
  <AppDrawer @close="emit('close')">
    <template #header>
      <span class="title">{{ $t('planner.select_ticket') }}</span>
    </template>
    <template #content>
      <TicketsSelectorMobileLoader
        v-if="activityDetailsStore.isLoading"
        @close="emit('close')"
      />
      <TicketsSelectorMobile
        v-else
        @close="emit('close')"
        @select-tickets="emit('select-tickets')"
      />
    </template>
  </AppDrawer>
</template>

<style scoped lang="scss">
.title {
  @include font-body-l-bold;
  color: var(--color-neutral-70);
}
</style>
